export interface HomeState {
  selectedCard: CardType | null
  unbornChild: boolean | null
  selectedServices?: ISDServiceDetails[]
}

export interface ISDServiceDetails {
  id: number
  name: string
  description: string
  s3Key: string | null
  allowShortForm: boolean
  hasAgeRange: boolean
}

export interface CaregiverShortFormState {
  firstName: string
  lastName: string
  email: string
  phone: string
  secondaryPhone: string | null
  doesNotHaveEmail: boolean
  doesNotHavePhone: boolean
  preferredContactMethodId: number | null
  primaryLanguageId: number | null
  address: string
  // location: PortalLocation
  currentlyHomeless: boolean
}

export interface ChildShortFormLayoutState {
  children: ChildShortFormState[]
  continueToLongForm?: boolean
}

export interface ChildShortFormState {
  key: number
  firstName: string
  lastName: string
  dateOfBirth: Date | null
  relationshipToChildId: number | null
  birthGender?: string | null
  primaryLanguageId?: number | null
  notes?: string | null
}

export interface ChildValidationState {
  firstName: FormField
  lastName: FormField
  dateOfBirth: FormField
  relationshipToChildId: FormField
}

export interface CaregiverValidationState {
  firstName: FormField
  lastName: FormField
  email: FormField
  phone: FormField
  preferredContactMethodId: FormField
  address: FormField
  // city: FormField
  // state: FormField
  // zipCode: FormField
}

export interface FormField {
  isDirty: boolean
  isValid: boolean
}

export interface msdsPeriod {
  periodID: number
  periodName: string
  startDate: Date | null
  endDate: Date | null
}

export enum CardType {
  MY_CHILD,
  OTHER_CHILD,
  MYSELF
}
